import { render, staticRenderFns } from "./PaceChartHc.vue?vue&type=template&id=6b081148&"
import script from "./PaceChartHc.vue?vue&type=script&lang=ts&"
export * from "./PaceChartHc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports